import baseApi from "../api/baseApi";

const studentProgressApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getAllStudentProgress: builder.query({
      query: () => ({
        url: "/studentprogress/getAllStudentProgress",
        method: "GET",
        credentials: "include",
      }),
      transformResponse: (response) => ({
        ...response,
        data: Array.isArray(response?.data) ? response.data : [],
      }),
      providesTags: [{ type: "StudentProgress", id: "LIST" }],
    }),
    getStudentProgress: builder.query({
      query: (studentId) => ({
        url: `/studentprogress/getStudentProgress/${studentId}`,
        method: "GET",
        credentials: "include",
      }),
      transformResponse: (response) => ({
        ...response,
        data: Array.isArray(response?.data) ? response.data : [],
      }),
      providesTags: (_result, _error, studentId) => [
        { type: "StudentProgress", id: studentId },
      ],
    }),
  }),
});

export const {
  useGetAllStudentProgressQuery,
  useGetStudentProgressQuery,
} = studentProgressApi;
